/*pinterest*/
var pinterestCollection = [];	
var pinterestPage = [];
var goEndPoint = "https://api.pinkyparadise.com/"

//console.log("pinterest.js");
//window.onload = function() {
  //console.log("window.onload execute / remove window.onload");
  var pinDiv = document.getElementById("pinterest")
  var handle = pinDiv.getAttribute("handle");
  var pid = pinDiv.getAttribute("productid");
  
  
 //console.log("calling displayPinterest");
  displayPinterest(pid);
  
//};


function displayPinterest(pid) {
  
  // console.log("displayPinterest", handle);

    var url = goEndPoint + 'api/spy/getPinterestLink';
  
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
  
        if (this.readyState == 4 && this.status == 200) {
            var jsonResp = JSON.parse(xhttp.responseText);
            //console.log("jsonResp", jsonResp);

            pinterestCollection = jsonResp
            if (jsonResp != null){
              
              
              
              
            if (jsonResp.length > 0){
              
                
                //console.log("jsonResp.length", jsonResp.length)
              
                var pinHead = document.createElement("h3");
                pinHead.id = "pinHead";
                pinHead.innerHTML = 'Customer Real Life Photo on <a href="https://www.pinterest.com/pinkyparadise2U/" target="_blank"><div style="display:inline-block"><img style="height: 20px;" src="https://cdn.shopify.com/s/files/1/0878/2578/files/iconmonstr-pinterest-1.svg?v=1626080896" alt="www.pinkyparadise.com on pinterest"> <span class="pinLogoText">Pinterest<span></div></a>'

                
                var gridgallery = document.createElement("script");
                gridgallery.type ="text/javascript";
                gridgallery.src = "https://cdn.shopify.com/s/files/1/0878/2578/files/grid-gallery.js?v=1626455358";
               
                
                var swipe = document.createElement("script");
                swipe.type ="text/javascript";
                swipe.src = "https://cdn.shopify.com/s/files/1/0878/2578/files/swiped-events.min.js";

                var gridcss = document.createElement("link");
                gridcss.setAttribute("rel", "stylesheet");
                gridcss.href = "https://cdn.shopify.com/s/files/1/0878/2578/files/grid-gallery.css";

                var bodyDiv = document.querySelector('body');

                var ggscreen = document.createElement("div")
                ggscreen.id = "gg-screen";
                ggscreen.style.visibility = "hidden";

                var ggContainer = document.createElement("div");
                ggContainer.className = "gg-container";
                if(jsonResp.length == 4){
                  ggContainer.setAttribute("style","max-width:1000px;margin:0px auto;");
            
                }else if(jsonResp.length == 3){
                  
                    ggContainer.setAttribute("style","max-width:750px;margin:0px auto;"); 
                }else if(jsonResp.length == 2){
                  
                    ggContainer.setAttribute("style","max-width:500px;margin:0px auto;"); 
                }else if(jsonResp.length == 1){
                  
                    ggContainer.setAttribute("style","max-width:250px;margin:0px auto;");
                }

                if (jsonResp.length < 5){
                    var pinWidth = (jsonResp.length * 200)+12;
                    //  console.log("pinterest pinWidth", pinWidth.toString());
                     ggContainer.style.width = pinWidth.toString()+"px!important;";
                      ggContainer.style.margin = "20px auto!important;";
                }
                
                var pinterestDiv = document.createElement("div");
                pinterestDiv.id = "pinGrid";
                pinterestDiv.className = "gg-box";
                pinterestDiv.setAttribute("data-layout","square");
                //pinterestDiv.setAttribute("data-theme", "dark");

                pinterestPage = paginate (jsonResp, 12)

                //console.log("pinterestPage ", pinterestPage);

               for (i = 0; i < pinterestPage[0].length; i++) { 


                    var pinItem = document.createElement("img");
                    var rawSize = jsonResp[i].src;
                    var enlarge = rawSize.replace("/236x","/564x");
                    //console.log("enlarge ", enlarge);
                    pinItem.src = enlarge;
                    pinItem.class = "pin-item";
                    pinItem.setAttribute("loading","lazy");
                    pinItem.setAttribute("pinLink",jsonResp[i].pinterestLink);

                    pinterestDiv.appendChild(pinItem);
                
               }

               ggContainer.appendChild(pinterestDiv);

               

                var pinBtn = document.createElement("div");
                pinBtn.id = "pinMore";
                 pinBtn.style.marginTop = "20px";
                pinBtn.className = "pinbutton pinbutton--load";
                pinBtn.setAttribute("aria-label","Load more images");
                pinBtn.setAttribute("page", "0");
                pinBtn.setAttribute("onclick","javascript:loadNextItems(this);");
                pinBtn.innerHTML = '<span class="pinbutton__text" style="background: 0 0;padding: 11px 22px 7px;color: #f6418a;border: 1px solid #f6418a;font-weight: bold;cursor: pointer;border-radius:0px;">Load more</span>'

                if (jsonResp.length > 12){
                ggContainer.appendChild(pinBtn);
                }
                //bodyDiv.appendChild(ggscreen);
                 
                // console.log("pin",  document.getElementById("pinterest"));
                 
                //bodyDiv.insertBefore(ggscreen, bodyDiv.firstChild);
                document.getElementById("pinterest").appendChild(pinHead);
                document.getElementById("pinterest").appendChild(gridcss);
                document.getElementById("pinterest").appendChild(ggContainer);
                document.querySelector("head").appendChild(gridgallery);
                document.querySelector("head").appendChild(swipe);
                setTimeout(function() {
                   enlargePin(0);
                }, 500)


               


            }  
          }

        }    

    } 
    var data = {};
    data.ID = pid;
    xhttp.open("POST", url, true);
    xhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    //xhttp.setRequestHeader("Access-Control-Allow-Origin", "*");
    xhttp.send(JSON.stringify(data)); 


    function paginate (arr, size) {
    return arr.reduce((acc, val, i) => {
        let idx = Math.floor(i / size)
        let page = acc[idx] || (acc[idx] = [])
        page.push(val)

        return acc
    }, [])
    }

}


function loadNextItems(ele){

    //console.log("current page", ele.getAttribute("page"));
    var nextPage = parseInt(ele.getAttribute("page")) + 1;

    if (nextPage < pinterestPage.length){

        var pinGrid = document.getElementById("pinGrid");

        for (i = 0; i < pinterestPage[nextPage].length; i++) { 

            var pinItem = document.createElement("img");
            var rawSize = pinterestPage[nextPage][i].src;
            var enlarge = rawSize.replace("/236x","/564x");
           // console.log("enlarge ", enlarge);
            pinItem.src = enlarge;
            pinItem.class = "pin-item";
            pinItem.setAttribute("loading","lazy");
            pinItem.setAttribute("pinLink",pinterestPage[nextPage][i].pinterestLink);

            if(pinGrid != null){
                pinGrid.appendChild(pinItem);
            }

        }
        var nPage = nextPage + 1;

        if(nPage < pinterestPage.length){
            ele.setAttribute("page", nextPage);
        }else{
            //hideloadmore btn
            document.getElementById("pinMore").style.display = "none"
        }
        
        var indexStart = nextPage * 12;
     
        enlargePin(indexStart);
               

    }

}